import { existsSync } from 'node:fs'
import { VERSION } from '../index.js'
import { getDefaultUvPath, getDefaultUvxPath } from '../provisioning/uv.js'
import { getMcpRegistrationStatus } from '../registration/mcp.js'

const noColor = process.env.NO_COLOR !== undefined

const GREEN = noColor ? '' : '\x1b[32m'
const RED = noColor ? '' : '\x1b[31m'
const DIM = noColor ? '' : '\x1b[2m'
const RESET = noColor ? '' : '\x1b[0m'

const CHECK = noColor ? '[ok]' : `${GREEN}✓${RESET}`
const CROSS = noColor ? '[x]' : `${RED}✗${RESET}`

export function showStatus(): void {
  const uvProvisioned = existsSync(getDefaultUvPath())
  const mcpStatus = getMcpRegistrationStatus()
  const mcpRegistered = mcpStatus.userScope
  const jcodemunchReady = existsSync(getDefaultUvxPath())

  const anyFailed = !uvProvisioned || !mcpRegistered || !jcodemunchReady

  console.log(`gsd-munch v${VERSION}`)
  console.log('')
  console.log('  Status:')
  console.log(
    `    Python/uv ........... ${uvProvisioned ? CHECK : CROSS} ${uvProvisioned ? 'provisioned' : 'not found'}`,
  )
  console.log(
    `    MCP server .......... ${mcpRegistered ? CHECK : CROSS} ${mcpRegistered ? 'registered' : 'not registered'}`,
  )
  console.log(
    `    jCodeMunch .......... ${jcodemunchReady ? CHECK : CROSS} ${jcodemunchReady ? 'ready' : 'not ready'}`,
  )
  if (anyFailed) {
    console.log(`    ${DIM}run: gsd-munch setup${RESET}`)
  }
  console.log('')
  console.log('  Commands:')
  console.log('    gsd-munch setup     Provision Python & register MCP')
  console.log('    gsd-munch doctor    Check installation health')
  console.log('')
  console.log('  GSD workflows available via Claude Code:')
  console.log(
    '    /gsd:new-project, /gsd:plan-phase, /gsd:execute-phase, /gsd:verify-work, /gsd:ship',
  )
}
